import styled, { css } from 'styled-components'

import { colors, fontWeights } from '@/styles'
import { Label } from '@/components/text'

const HorizontalStyle = css`
  flex: 1;
  color: ${p => (p.isSelected ? colors.white : colors.black)};
  background: ${p => (p.isSelected ? colors.blue16 : 'none')};
  font-weight: ${fontWeights.medium};
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const VerticalStyle = css`
  color: ${colors.grey24};
  background: ${colors.white};
  height: 40px;
  display: flex;
  align-items: center;
  padding: 12px 4px;

  &:hover,
  &:active {
    color: ${p => (p.isSelected ? colors.grey24 : colors.grey40)};
  }

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }

  > div {
    font-weight: ${p => (p.isSelected ? 700 : 400)};
    background: ${p => (p.isSelected ? colors.blue96 : colors.white)};
    width: 100%;
    text-align: left;
    padding: 8px;
    border-radius: 8px;
  }
`

const Wrapper = styled.button.attrs(() => ({
  align: ({ horizontal }) => (horizontal ? 'center' : 'left')
}))`
  border-radius: 6px;
  cursor: 'pointer';
  border: 1px solid ${colors.grey88};
  padding: 0;

  ${({ horizontal }) => (horizontal ? HorizontalStyle : VerticalStyle)};

  ${p =>
    p.showSelect &&
    p.isSelected &&
    `
    border-color: ${colors.secondary};
  `};

  ${({ customStyle }) => customStyle};
`

const OptionItem = ({
  children,
  value = null,
  onClick = () => {},
  isSelected = false,
  showSelect = true,
  ...rest
}) => (
  <Wrapper
    {...rest}
    isSelected={isSelected}
    showSelect={showSelect}
    onClick={() => onClick(value)}
    type="button"
  >
    <Label fontSize="14px" type="medium">
      {children}
    </Label>
  </Wrapper>
)

export default OptionItem
